<template>
  <VRow>
    <VCol :cols="labelCols" class="align-self-center">
      <span class="label">
        {{ label + ': ' }}
      </span>
    </VCol>
    <VCol :cols="valueCols" :class="'align-self-center ' + valueCls">
      <span v-if="value">
        {{ value }}
      </span>
      <slot name="value" />
    </VCol>
  </VRow>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true,
    default: () => '',
  },
  labelCols: {
    type: [String, Number],
    required: false,
    default: () => 5,
  },
  valueCols: {
    type: [String, Number],
    required: false,
    default: () => 7,
  },
  value: {
    type: [String, Number],
    required: false,
    default: () => '',
  },
  valueCls: {
    type: String,
    required: false,
    default: () => '',
  },
});
</script>

<style lang="scss" scoped>
.label {
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
}
</style>
